const services = [
  {
    icon: "ri-time-line",
    title: "Emergency Passport",
    description: "Petrochemical turnaround in Saudi Arabia with two weeks to departure? Casino industry conference in Macau? Our emergency courier service prioritizes your application and submits directly via reserved agency slots — as fast as 24 hours.",
    bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
    badge: "Same-Day Available",
    link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
  },
  {
    icon: "ri-refresh-line",
    title: "Passport Renewal",
    description: "Already hold a U.S. passport? We help Lake Charles residents renew fast — no agency visit required for most renewals. Perfect for industrial engineers, hospitality professionals, and Southwest Louisiana families preparing for international travel.",
    bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
    badge: "Most Common",
    link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
  },
  {
    icon: "ri-file-add-line",
    title: "New Passport",
    description: "First-time applicants typically require an in-person acceptance clerk visit. We guide you through every step, from downtown Lake Charles to the clerk's office, with clear instructions for Southwest Louisiana residents.",
    bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
  },
  {
    icon: "ri-search-eye-line",
    title: "Lost or Stolen Passport",
    description: "Replacements often require additional forms. We guide you through exactly what is needed to avoid costly mistakes and delays, so your industrial assignment or family cruise is not derailed.",
    bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
  },
  {
    icon: "ri-parent-line",
    title: "Child Passport",
    description: "Minors (15 and under) require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family vacation or student exchange program stays on schedule.",
    bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
  },
  {
    icon: "ri-edit-line",
    title: "Name Change",
    description: "After marriage, divorce, or a legal name change — we assist with corrected passports and data corrections so your travel documents match your reservations and professional credentials.",
    bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=name-change",
  },
  {
    icon: "ri-book-2-line",
    title: "Second Passport & Damaged",
    description: "Need a second passport for frequent international travel, or replacing a significantly damaged one? We handle both efficiently — ideal for petrochemical engineers, casino executives, and consultants who cross borders regularly.",
    bullets: ["Frequent traveler solutions", "Damaged passport replacement", "Expedited processing"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
  },
];

export default function LakeCharlesServicesSection() {
  return (
    <section id="services" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Our Services</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Services We Expedite for Lake Charles Travelers
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you need a renewal before a petrochemical assignment in the Middle East, a first-time passport for a Caribbean cruise, or an emergency replacement before an industry conference — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30&ndash;100% less than FedEx, Staples, and other third-party passport courier resellers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <div
              key={i}
              className="group relative bg-white border border-gray-200 rounded-lg p-6 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
            >
              {service.badge && (
                <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  {service.badge}
                </span>
              )}
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
                <i className={`${service.icon} text-[#1A365D] text-xl`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{service.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{service.description}</p>
              <ul className="space-y-1.5 mb-6 flex-1">
                {service.bullets.map((b, j) => (
                  <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                    {b}
                  </li>
                ))}
              </ul>
              <a
                href={service.link}
                className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap"
              >
                Get Started <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}